import React from 'react'
import Field from 'src/shared/components/Field'
import useFormConfig from './formConfig'
import Button from '../../../Button'
import { FormHelperText, Typography } from '@material-ui/core'
import { sendEventType, stateType } from '../..'
import useSendingEmail from 'src/shared/services/postEmail/hooks'
import useStyles from './useStyles'

interface Props {
  send: sendEventType

  state: stateType
  isResetPage?: boolean
}

const EmailForm: React.FC<Props> = ({ send, state, isResetPage }) => {
  const classes = useStyles()
  const { mutate, isLoading } = useSendingEmail(send, isResetPage)
  const { register, handleSubmit, onSubmit, errors } = useFormConfig(mutate)
  const isTickStart = state.matches({ emailForm: 'tickStart' })
  const { duration, elapsed } = state.context

  return (
    <>
      <Typography variant='h5' className={classes.mainTitle}>
        重置密碼
      </Typography>
      <FormHelperText className={classes.heplerText}>請輸入您的電子郵件地址，我們將寄出密碼重置信給您</FormHelperText>
      <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
        <Field
          placeholder='Username@brightenoptix.com'
          ref={register}
          label='亨泰電子郵件地址'
          name='email'
          error={Boolean(errors.email)}
          labelClassName={classes.emailLabel}
          errorMessage={errors?.email?.message}
        />
        <Button disabled={isLoading || isTickStart} type='submit'>
          {isTickStart ? `寄給我重置密碼信(${Math.ceil(duration - elapsed)})` : '寄給我重置密碼信'}
        </Button>
      </form>
    </>
  )
}

export default EmailForm
